import { render, staticRenderFns } from "./BlacklistManagement.vue?vue&type=template&id=06dd2388&scoped=true"
import script from "./BlacklistManagement.vue?vue&type=script&lang=js"
export * from "./BlacklistManagement.vue?vue&type=script&lang=js"
import style0 from "./BlacklistManagement.vue?vue&type=style&index=0&id=06dd2388&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06dd2388",
  null
  
)

export default component.exports